import React from 'react';
import type {AIEvent, AIResponse, Citation, SearchDocument} from "@/types";
import { ThinkEvent } from './ThinkEvent';
import { AnswerEvent } from './AnswerEvent';
import { EndEvent } from './EndEvent';

interface RenderEventProps {
    event: AIEvent;
    index: number;
    conversationNo: string;
    isLatestMessage: boolean;
    isEnd?: boolean;
    thinkStop?: boolean;
    citations?: Citation[];
    doc?: SearchDocument[];
    isThink?: boolean;
    messageGroup?: AIResponse;
    groupIndex?: number;
    setMessages: React.Dispatch<React.SetStateAction<AIResponse[]>>;
    onUnderAnswer?: (num?: number) => void;
}

export const RenderEvent = React.memo((props: RenderEventProps) => {
    const {
        event,
        isLatestMessage,
        citations,
        conversationNo,
        doc,
        isThink,
        messageGroup,
        groupIndex,
        setMessages,
        isEnd,
        thinkStop,
        onUnderAnswer
    } = props;
    switch (event.event) {
        case 'THINK':
            return (
                <ThinkEvent
                    event={event}
                    citations={citations}
                    conversationNo={conversationNo}
                    doc={doc}
                    thinkStop={thinkStop}
                    isLatestMessage={isLatestMessage}
                    isThink={isThink}
                    messageGroup={messageGroup}
                    groupIndex={groupIndex}
                    setMessages={setMessages}
                />
            );

        case 'ANSWER':
            return (
                <AnswerEvent
                    event={event}
                    citations={citations}
                    conversationNo={conversationNo}
                    doc={doc}
                    isLatestMessage={isLatestMessage}
                    messageGroup={messageGroup}
                    setMessages={setMessages}
                    onUnderAnswer={onUnderAnswer}
                    isEnd={isEnd}
                    groupIndex={groupIndex}
                />
            );

        case 'END':
            return <EndEvent />;

        default:
            return null;
    }
});
